<template>
  <v-simple-table dense>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left blue-grey lighten-3" style="text-align: left">
            THN
          </th>
          <th class="text-left blue-grey lighten-3" style="text-align: left">
            JAN
          </th>
          <th class="text-left blue-grey lighten-3" style="text-align: left">
            FEB
          </th>
          <th class="text-left blue-grey lighten-3" style="text-align: left">
            MAR
          </th>
          <th class="text-left blue-grey lighten-3" style="text-align: left">
            APR
          </th>
          <th class="text-left blue-grey lighten-3" style="text-align: left">
            MAY
          </th>
          <th class="text-left blue-grey lighten-3" style="text-align: left">
            JUN
          </th>
          <th class="text-left blue-grey lighten-3" style="text-align: left">
            JUL
          </th>
          <th class="text-left blue-grey lighten-3" style="text-align: left">
            AUG
          </th>
          <th class="text-left blue-grey lighten-3" style="text-align: left">
            SEP
          </th>
          <th class="text-left blue-grey lighten-3" style="text-align: left">
            OCT
          </th>
          <th class="text-left blue-grey lighten-3" style="text-align: left">
            NOV
          </th>
          <th class="text-left blue-grey lighten-3" style="text-align: left">
            DEC
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(subItemChild, index) in subItem" :key="index">
          <td class="blue-grey lighten-3">{{ subItemChild.YEAR }}</td>
          <td :class="colorTableClass(subItemChild.JAN !== null ? subItemChild.JAN.QualityCode : '')">
            {{ valueQualityCode(subItemChild.JAN !== null ? subItemChild.JAN : '') }}
          </td>
          <td :class="colorTableClass(subItemChild.FEB !== null ? subItemChild.FEB.QualityCode : '')">
            {{ valueQualityCode(subItemChild.FEB !== null ? subItemChild.FEB : '') }}
          </td>
          <td :class="colorTableClass(subItemChild.MAR !== null ? subItemChild.MAR.QualityCode : '')">
            {{ valueQualityCode(subItemChild.MAR !== null ? subItemChild.MAR : '') }}
          </td>
          <td :class="colorTableClass(subItemChild.APR !== null ? subItemChild.APR.QualityCode : '')">
            {{ valueQualityCode(subItemChild.APR !== null ? subItemChild.APR : '') }}
          </td>
          <td :class="colorTableClass(subItemChild.MEI !== null ? subItemChild.MEI.QualityCode : '')">
            {{ valueQualityCode(subItemChild.MEI !== null ? subItemChild.MEI : '') }}
          </td>
          <td :class="colorTableClass(subItemChild.JUN !== null ? subItemChild.JUN.QualityCode : '')">
            {{ valueQualityCode(subItemChild.JUN !== null ? subItemChild.JUN : '') }}
          </td>
          <td :class="colorTableClass(subItemChild.JUL !== null ? subItemChild.JUL.QualityCode : '')">
            {{ valueQualityCode(subItemChild.JUL !== null ? subItemChild.JUL : '') }}
          </td>
          <td :class="colorTableClass(subItemChild.AUG !== null ? subItemChild.AUG.QualityCode : '')">
            {{ valueQualityCode(subItemChild.AUG !== null ? subItemChild.AUG : '') }}
          </td>
          <td :class="colorTableClass(subItemChild.SEP !== null ? subItemChild.SEP.QualityCode : '')">
            {{ valueQualityCode(subItemChild.SEP !== null ? subItemChild.SEP : '') }}
          </td>
          <td :class="colorTableClass(subItemChild.OCT !== null ? subItemChild.OCT.QualityCode : '')">
            {{ valueQualityCode(subItemChild.OCT !== null ? subItemChild.OCT : '') }}
          </td>
          <td :class="colorTableClass(subItemChild.NOV !== null ? subItemChild.NOV.QualityCode : '')">
            {{ valueQualityCode(subItemChild.NOV !== null ? subItemChild.NOV : '') }}
          </td>
          <td :class="colorTableClass(subItemChild.DEC !== null ? subItemChild.DEC.QualityCode : '')">
            {{ valueQualityCode(subItemChild.DEC !== null ? subItemChild.DEC : '') }}
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>

export default {
  name: 'ChildTableComponent',
  props: ["subItem"],
  methods: {
    colorTableClass(qualityCode) {
      if (qualityCode == '') {
        return 'white'
      } else if (qualityCode == 1) {
        return 'green'
      } else if (qualityCode == 2) {
        return 'yellow'
      } else if (qualityCode == 3) {
        return 'amber'
      } else if (qualityCode == 4) {
        return 'orange'
      } else if (qualityCode == 5) {
        return 'red'
      }
    },

    valueQualityCode(queryData) {
      if (queryData.ReferenceMonth && queryData.QualityCode == '') {
        return 'N/A'
      } else if (queryData.ReferenceMonth && queryData.QualityCode == 1) {
        return 'OK'
      } else if (queryData.ReferenceMonth && queryData.QualityCode == 2) {
        return '1-89'
      } else if (queryData.ReferenceMonth && queryData.QualityCode == 3) {
        return '90-119'
      } else if (queryData.ReferenceMonth && queryData.QualityCode == 4) {
        return '120-179'
      } else if (queryData.ReferenceMonth && queryData.QualityCode == 5) {
        return '180+'
      } else {
        return ''
      }
    }
  }
}
</script>